export default "dist/images/block-testimonial-vertical-inverse.9972470.png";